import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermitSummaryService {

  private summarySource = new BehaviorSubject<PermitSummary[]>(null);
  currentSummary = this.summarySource.asObservable();

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    @Inject(LOCALE_ID) private locale: string,
    private http: HttpClient
  ) { }

  getSummary() {
    this.http.get<PermitSummary[]>(`${this.baseUrl}api/permitsummary`).subscribe(
      response => {
        if (response) {
          var formatted = response.map(item => this.formatPermitSummaryDates(item));
          this.summarySource.next(formatted);
        }
      },
      error => console.error(error)
    );
  }

  formatPermitSummaryDates(permitSummary: PermitSummary): PermitSummary {
    permitSummary.permitStartDateFormatted = formatDate(permitSummary.permitStartDate, 'MM/dd/yyyy', this.locale);
    permitSummary.permitEndDateFormatted = formatDate(permitSummary.permitEndDate, 'MM/dd/yyyy', this.locale);
    return permitSummary;
  }
}

export interface PermitSummary {
  applicationPackageId: number,
  applicationNumber: string,
  waterRightsId: string,
  permitStatus: string,
  permitVarianceNumber: string,
  aopStatus: string,
  permitTypeName: string,
  permitYear: number,
  permitStartDate: number,
  permitStartDateFormatted: string
  permitEndDate: number,
  permitEndDateFormatted: string,
  appropriatorName: string,
  diversionName: string,
  facilityCount: number,
  facilityList: string[]
}
